module.exports = __webpack_public_path__ + "img/view-detail.fc74e26f.svg";